var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{style:(_vm.cardType.rotate ? ("transform: rotate(" + (_vm.cardType.rotate) + ")") : null),attrs:{"color":_vm.cardType.color,"size":_vm.size}},[_vm._v("\n  "+_vm._s(_vm.cardType.icon)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }